'use client';

import { useEffect, useState, type ReactElement } from 'react';
import { createPortal } from 'react-dom';
import { useMediaQuery } from 'react-responsive';
import Modal from '../modal';
import HorizontalLine from '../horizontal-line';
import BevSafeText from '../bev-safe-text';

export type Props = {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	cancellationPolicy: string;
};

export default function CancellationPolicyModal({
	isOpen,
	onClose,
	title,
	cancellationPolicy,
}: Props): ReactElement | null {
	const isMobile = useMediaQuery({ maxWidth: 959 });
	const [mounted, setMounted] = useState(false);

	useEffect(() => setMounted(true), []);

	if (!isOpen || !mounted) return null;

	return createPortal(
		<div className="tailwind-root">
			<Modal
				close={onClose}
				mobileFullScreen={false}
				mobileAnimate
				isMobile={isMobile}
				contentContainerClassNames="justify-start"
			>
				<div className="flex w-full flex-col spacing-stack-m pb-400 md:pb-500">
					<h2 className="text-text-heading text-subtitle1">
						<BevSafeText>{title}</BevSafeText>
					</h2>
					<HorizontalLine />
					<div
						className="text-text-primary text-body3"
						dangerouslySetInnerHTML={{ __html: cancellationPolicy }}
					/>
				</div>
			</Modal>
		</div>,
		document.body
	);
}
